// extracted by css-extract-rspack-plugin
export default {"wysiwyg":"navigation-fragment__Wysiwyg_wysiwyg__IaBpx"};